const CMS_UPDATE_PREVIEW_OPTIONS = 'CMS_UPDATE_PREVIEW_OPTIONS';
export default CMS_UPDATE_PREVIEW_OPTIONS;
